var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"preloader"},[_c('div',{staticClass:"preloader__icon"},[_c('svg-inline',{staticClass:"preloader__icon-svg"},[_c('icon',{attrs:{"icon":"loader-circle-large"}})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }